"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFound = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("@chakra-ui/react");
var PageNotFound_1 = require("../../common/error/PageNotFound");
var layout_1 = require("../../common/layout");
var useShop_1 = require("../../common/hooks/useShop");
var PageLoading_1 = require("../../common/loading/PageLoading");
var NotFound = function () {
    var _a = (0, useShop_1.useShop)(), shopData = _a.shopData, isShopLoading = _a.isShopLoading, mainShopData = _a.mainShopData;
    if (isShopLoading)
        return react_1.default.createElement(PageLoading_1.PageLoading, null);
    if (!shopData)
        return (react_1.default.createElement(layout_1.Layout, { headerUrl: mainShopData === null || mainShopData === void 0 ? void 0 : mainShopData.logo_image },
            react_1.default.createElement(react_2.Box, { padding: "5rem" },
                react_1.default.createElement(PageNotFound_1.PageNotFound, null))));
    return (react_1.default.createElement(layout_1.Layout, { headerUrl: shopData.logo_image, shopCode: shopData.code, isHeader: true, isFooter: true, isLoading: isShopLoading },
        react_1.default.createElement(react_2.Box, { padding: "5rem" },
            react_1.default.createElement(PageNotFound_1.PageNotFound, null))));
};
exports.NotFound = NotFound;
